<script>
export default {
  name: 'NavigationError',

  props: {
    title: {
      type: String,
      default: 'Parece que algo deu errado'
    },

    description: {
      type: String,
      default: '',
    },

    image: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          typeof value === 'object' &&
          value !== null &&
          'url' in value &&
          'alt' in value
        );
      },
    },

    redirectPath: {
      type: String,
      default: '/painel',
    },
  },

  methods: {
    handleRedirect(path) {
      window.location.href = path;
    },
  },
}
</script>

<template>
  <section class="navigation-error">
    <div class="navigation-error__wrapper">
      <div class="navigation-error__content">
        <div class="navigation-error__title">
          <slot name="title">
            <h1>{{ title }}</h1>
          </slot>
        </div>

        <div
          v-if="description || $slots.description"
          class="navigation-error__description"
        >
          <slot name="description">
            <p>{{ description }}</p>
          </slot>
        </div>

        <slot name="actions">
          <button
            type="button"
            class="mui-button mui-button--primary"
            @click="handleRedirect(redirectPath)"
          >
            Voltar para o início
          </button>
        </slot>
      </div>

      <div class="navigation-error__image">
        <img
          :src="image.url"
          :alt="image.alt"
        >
      </div>
    </div>
  </section>
</template>

<style lang="stylus" scoped>
@import '~commons/stylus/core/_vars'

.navigation-error
  height 100dvh
  background-color $catskillWhite

  &__wrapper
    height 100%
    padding-top 56px
    display flex
    align-items center
    flex-direction column
    box-sizing border-box

  &__content
    width 70%
    height 45%
    display flex
    flex-direction column
    align-items center
    justify-content center
    text-align center

  &__title
    font-family $lato
    color $brightGray
    font-size 24px
    font-weight 700
    margin-bottom 16px

  &__description
    color $brightGray
    font-weight 400
    font-size 16px
    line-height 1.2
    margin-bottom 32px

  &__image
    width 100%
    height 55%
    overflow hidden

    img
      width 100%
      height 100%
      object-fit cover

  @media screen and (min-width: 814px)
    &__wrapper
      padding-top 72px
      flex-direction row-reverse

    &__content
      width 50%
      align-items start
      text-align left
      padding-inline 88px

    &__image
      width 50%
      height 100%
</style>